import { BarBadgeId, BarId } from "./enums"

export interface Bar {
  id: BarId
  title: string
  address: string
  latlng: { lat: number; lng: number }
  closed?: boolean
  info?: {
    review: string[]
    ratings: {
      Размер: number
      Атмосфера: number
      Цены: number
      Напитки: number
      Еда: number
      Музыка: number
    }
    badges: BarBadgeId[]
  }
}

export const bars: Bar[] = [
  // Миля 1
  {
    id: BarId.Samocvet,
    title: "Самоцвет",
    address: "​Малышева, 29а, 1 этаж",
    latlng: { lat: 56.83360877076948, lng: 60.594615340232856 },
    info: {
      review: [
        "Самоцвет — известный и популярный бар недалеко от Вайнера, где летом собирается огромное число людей. Внутри есть целых два этажа. На первом вам нальют хорошее крафтовое пиво и неплохие коктейли, на втором этаже вас ждёт удивительная атмосфера танцев и порой странной и загадочной музыки.",
        "Цены приемлемые. Публика адекватная. Музыка хорошая.",
        "Внимание: если очень громко орать перед входом песню 'Я так соскучился', то могут не пустить в бар. Мы орали. Нас не пустили. Ну и ладно, не очень-то хотелось.",
        "Даниила не пустили в этот бар 2 раза.",
      ],
      badges: [BarBadgeId.CraftBeer, BarBadgeId.DancePool],
      ratings: {
        Размер: 2,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 3,
        Еда: 0,
        Музыка: 4,
      },
    },
  },
  {
    id: BarId.DvaDeda,
    title: "Два деда",
    address: "​Малышева, 27, 1 этаж",
    latlng: { lat: 56.83354123546365, lng: 60.59405207633973 },
    info: {
      review: ["Два деда бесплатно угостили нас настройками."],
      badges: [BarBadgeId.GoodTincture],
      ratings: {
        Размер: 5,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Health,
    title: "Здоровье",
    address: "​Малышева, 19, 1 этаж",
    latlng: { lat: 56.83304793040498, lng: 60.590130686759956 },
    info: {
      review: [
        "Минималистичный бар в стиле старой кухни, где вам нальют замечательные настойки. В помещении есть лестница, с которой можно навернуться, будьте осторожны.",
        "Также в зале есть телефон.",
      ],
      badges: [BarBadgeId.GoodTincture, BarBadgeId.GoodDesign],
      ratings: {
        Размер: 4,
        Атмосфера: 5,
        Цены: 5,
        Напитки: 4,
        Еда: 0,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Irish,
    title: "Ирландский дворик",
    address: "​Малышева, 11, 1 этаж",
    latlng: { lat: 56.832554618847574, lng: 60.58610200881959 },
    info: {
      review: [
        "Мы провели тут всего ничего, но сделали вывод, что это самый уютный бар из всех.",
        "Есть большой второй зал, свет в котором был таинственно погашен.",
        "Настойки и коктейли были очень хороши.",
      ],
      badges: [
        BarBadgeId.GoodTincture,
        BarBadgeId.GoodCocktails,
        BarBadgeId.GoodDesign,
      ],
      ratings: {
        Размер: 4,
        Атмосфера: 5,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.InnocentPeople,
    title: "Невинные люди",
    address: "​Радищева, 24, 1 этаж",
    latlng: { lat: 56.83034344613, lng: 60.58757185935975 },
    info: {
      review: [
        "Мы ворвались в этот бар, когда там уже убирались, выпили настойки и убежали обратно, оставив всех в недоумении.",
        "Им пришлось нас напоить.",
        "Они не виноваты.",
      ],
      badges: [BarBadgeId.GoodTincture],
      ratings: {
        Размер: 4,
        Атмосфера: 0,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Pravda,
    title: "Pravda",
    address: "​Шейнкмана, 90, цокольный этаж",
    latlng: { lat: 56.82680501761815, lng: 60.59459388256074 },
    info: {
      review: [
        "Сюда мы пришли в депрессивной фазе нашей прогулки. Я помню только то, что тут был телефон. И хорошие настойки.",
      ],
      badges: [BarBadgeId.GoodTincture],
      ratings: {
        Размер: 5,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.NeBar,
    title: "NeBar",
    address: "​Радищева, 25, 1 этаж",
    latlng: { lat: 56.829871550505494, lng: 60.59247493743897 },
    info: {
      review: [
        "Бар на втором этаже с хорошим видом из окна и залом, но с настолько ужасно громкой музыкой, что я потерял понимание пространства, времени и смысла своей жизни.",
        "Бармен налила мне что-то, что отправило меня ещё дальше в глубины небытия, и я увидел мрачные бездны неназываемых вещей.",
        "Выбравшись из бара на автопилоте, я забрался на балкон за зданием и лежал там, пока не вспомнил, кто я.",
      ],
      badges: [
        BarBadgeId.BadMusic,
        BarBadgeId.GoodCocktails,
        BarBadgeId.GoodDesign,
      ],
      ratings: {
        Размер: 5,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 1,
      },
    },
  },
  // Миля 2
  {
    id: BarId.Mon,
    title: "Мон",
    address: "​Большакова, 99а, 1 этаж",
    latlng: { lat: 56.81681509435719, lng: 60.60208797454835 },
  },
  {
    id: BarId.Sova,
    title: "Sova",
    address: "​Шейнкмана, 123, 2 этаж",
    latlng: { lat: 56.817963397997325, lng: 60.59381604194642 },
  },
  {
    id: BarId.Mango,
    title: "Mango",
    address: "​Шейнкмана, 110а, 1 этаж",
    latlng: { lat: 56.82276942538319, lng: 60.5878347158432 },
  },
  {
    id: BarId.Kaifooi,
    title: "KAIFOOI",
    address: "​Хохрякова, 72, 1 этаж",
    latlng: { lat: 56.827827306924505, lng: 60.594127178192146 },
  },
  {
    id: BarId.OurBar,
    title: "Свой бар",
    address: "​Вайнера, 60, 1 этаж",
    latlng: { lat: 56.82844108647872, lng: 60.59670746326447 },
  },
  {
    id: BarId.Nravs,
    title: "Нравы",
    address: "​Радищева, 21",
    latlng: { lat: 56.82990060798617, lng: 60.59557020664216 },
    info: {
      review: [
        "Бар для аристократии и интеллигенции.",
        "Над столиками есть лампы, которые хочется шатать и качать.",
        "Удобные кресла, чтобы сидеть и общаться о высоком.",
      ],
      badges: [BarBadgeId.GoodCocktails, BarBadgeId.GoodDesign],
      ratings: {
        Размер: 5,
        Атмосфера: 5,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Stereotypes,
    title: "Стереотипы",
    address: "8 Марта, 20а",
    latlng: { lat: 56.831985387595005, lng: 60.600355267524726 },
  },
  {
    id: BarId.NewBar,
    title: "New Bar",
    address: "8 Марта, 8д, 3 этаж; 2 подъезд",
    latlng: { lat: 56.835100309556275, lng: 60.598998069763184 },
    info: {
      review: [
        "Один из худших баров города. Отвратительное расположение, неадекватная охрана, полное неумение делать коктейли, никакого выбора напитков и крайне скверная атмфосфера",
        "К посещению не рекомендуется",
      ],
      badges: [
        BarBadgeId.GoodCocktails,
        BarBadgeId.UniqueCocktails,
        BarBadgeId.GoodDesign,
        BarBadgeId.Games,
      ],
      ratings: {
        Размер: 1,
        Атмосфера: 1,
        Цены: 1,
        Напитки: 1,
        Еда: 0,
        Музыка: 1,
      },
    },
  },
  // Миля 3
  {
    id: BarId.Television,
    title: "Телевизор",
    address: "​​Радищева, 4, цокольный этаж",
    latlng: { lat: 56.8308373849115, lng: 60.60003876686097 },
    info: {
      review: [
        "Небольшой спортивный бар с крафтом.",
        "Все стены обклеены наклейками, смотрится мощно.",
      ],
      badges: [BarBadgeId.CraftBeer, BarBadgeId.Sabotage],
      ratings: {
        Размер: 2,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Strelka,
    title: "Стрелка",
    address: "8 Марта, 18, 1 этаж",
    latlng: { lat: 56.831980239014534, lng: 60.59987246990204 },
    info: {
      review: [
        "Небольшой уютный бар с разными пивами. Есть диван для большой компании, но только для одной, поэтому если там уже есть компания, то вторая компания туда уже не влезет.",
        "Во дворе бара есть лестница, на которую я залез пьяный, и меня оттуда пытались снять.",
      ],
      badges: [BarBadgeId.GoodBeer, BarBadgeId.CraftBeer],
      ratings: {
        Размер: 2,
        Атмосфера: 5,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.DoubleGrill,
    title: "Double grill and bar",
    address: "8 Марта, 8Б, 1 этаж",
    latlng: { lat: 56.83689571943298, lng: 60.59874057769776 },
  },
  {
    id: BarId.Gastrols,
    title: "Гастроли",
    address: "8 Марта, 4, 1 этаж",
    latlng: { lat: 56.8392925971454, lng: 60.597957372665405 },
  },
  {
    id: BarId.Fireside,
    title: "Fireside Bar",
    address: "Ельцина, 8, 1 этаж",
    latlng: { lat: 56.84286897723481, lng: 60.59157371520997 },
  },
  {
    id: BarId.Baiks,
    title: "Байки",
    address: "​Олимпийская набережная, 9/1, 1 этаж",
    latlng: { lat: 56.8493993229686, lng: 60.593166947364814 },
  },
  {
    id: BarId.Tarantino,
    title: "Однажды в Тарантино",
    address: "​Некрасова, 14, 1 этаж",
    latlng: { lat: 56.850789161333935, lng: 60.5888056755066 },
  },
  // {
  //   title: "Медный грош",
  //   description: "​​​улица Свердлова, 25, цокольный этаж",
  //   latlng: { lat: 56.853211110984184, lng: 60.60443222522736 },
  // },

  // extra bars
  {
    id: BarId.TheOutBar,
    title: "The out bar",
    address: "8 Марта, 31в, 1 этаж",
    latlng: { lat: 56.83161245756649, lng: 60.600891709327705 },
  },
  {
    id: BarId.Nelson,
    title: "Нельсон Совин",
    address: "​Малышева, 21/4, 1 этаж",
    latlng: { lat: 56.83384665630763, lng: 60.591906309127815 },
    info: {
      review: [
        "Бар, в котором тысячи кранов, самый пивной бар в городе. Также есть несколько холодильников с крафтом. Мест достаточно много, два этажа и места на улице.",
        "Если пить хорошее пиво, то только здесь. Но цены серьёзные, одна банка пива стоит $5000.",
        "Есть закуски в виде орехов, сыра, мёда.",
      ],
      badges: [BarBadgeId.GoodBeer, BarBadgeId.CraftBeer, BarBadgeId.Sabotage],
      ratings: {
        Размер: 5,
        Атмосфера: 4,
        Цены: 2,
        Напитки: 5,
        Еда: 3,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Americanka,
    title: "Americanka",
    address: "Малышева, 29, 1 этаж",
    latlng: { lat: 56.83375594409528, lng: 60.59548437595368 },
  },
  {
    id: BarId.Killfish,
    title: "Killfish",
    address: "​Вайнера, 9а, 2 этаж",
    latlng: { lat: 56.834961897415006, lng: 60.59553265571595 },
  },
  {
    id: BarId.Killfish,
    title: "Югославия Гриль",
    address: "​Гоголя, 36",
    latlng: { lat: 56.830712013317026, lng: 60.610633492469795 },
  },
  {
    id: BarId.Bones50,
    title: "50 костей",
    address: "8 Марта, 23в",
    latlng: { lat: 56.83300728383372, lng: 60.6004410982132 },
  },
  {
    id: BarId.InTouch,
    title: "InTouch Cocktail Bar",
    address: "​​​Розы Люксембург, 23, 1 этаж",
    latlng: { lat: 56.8318567377988, lng: 60.613374710083015 },
    info: {
      review: [
        "Бар с уникальными коктейлями, самыми необычными в городе и в мире. Здесь есть коктейль из рыбного дистилята, вы такое больше нигде не найдёте. И не надо мне говорить, что это фу, вы ничего не понимаете!",
        "Место очень атмосферное и зачастую тихое и спокойное.",
        "Есть ковёр.",
        "Есть котики.",
      ],
      badges: [BarBadgeId.GoodCocktails, BarBadgeId.UniqueCocktails],
      ratings: {
        Размер: 4,
        Атмосфера: 5,
        Цены: 4,
        Напитки: 5,
        Еда: 3,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Kam,
    title: "НСБ by Kam Lounge",
    address: "​​​Розы Люксембург, 8/10, 2 этаж",
    latlng: { lat: 56.834542262732874, lng: 60.61175465583802 },
  },
  {
    id: BarId.Three,
    title: "Три толстяка",
    address: "​​​Вайнера, 60, 1 этаж",
    latlng: { lat: 56.82842583094826, lng: 60.59718489646912 },
  },
  {
    id: BarId.Prorock,
    title: "Prorock",
    address: "8 Марта, 13, цокольный этаж",
    latlng: { lat: 56.83615629009294, lng: 60.600875616073616 },
  },
  {
    id: BarId.Sbors,
    title: "Сборы",
    address: "8 Марта, 18а",
    latlng: { lat: 56.83239061443931, lng: 60.599153637886054 },
    info: {
      review: [
        "В этом баре подают божественного вкуса картошечку и наггетсы. Есть кальян. Есть коктейли.",
      ],
      badges: [BarBadgeId.GoodCocktails, BarBadgeId.Hookah],
      ratings: {
        Размер: 4,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Slova,
    title: "Слова",
    address: "8 Марта, 18",
    latlng: { lat: 56.83245245307503, lng: 60.60017824172974 },
    info: {
      review: [
        "Невероятно маленький бар, где стоит полтора стола, но в котором тебе легко и дёшево дадут испить отличные настойки.",
        "Пиво тут лучше не брать.",
      ],
      badges: [BarBadgeId.GoodTincture, BarBadgeId.BadBeer],
      ratings: {
        Размер: 1,
        Атмосфера: 3,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Collective,
    title: "Коллектив",
    address: "8 Марта, 8г, 2 этаж",
    latlng: { lat: 56.835486912253856, lng: 60.59822022914887 },
    info: {
      review: [
        "Место, где можно солидно вкинуться коктейлями с поражающим воображение количеством алкоголя.",
        "Тут весьма тесно и неудобно сидеть, а иногда приходится стоять.",
        "Даниила не пустили в этот бар 3 раза.",
      ],
      badges: [BarBadgeId.GoodCocktails, BarBadgeId.UniqueCocktails],
      ratings: {
        Размер: 2,
        Атмосфера: 2,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Grott,
    title: "Grott Bar",
    address: "​проспект Ленина, 49, 1 этаж",
    latlng: { lat: 56.83996546026788, lng: 60.6147587299347 },
    info: {
      review: [
        "Этот бар считается классическим, сюда ходят люди, которые уже преисполнились всем в этой жизни.",
        "Тесное и запутанное заведение, но зато встречают у входа, как царя, и есть гардерод.",
        "Хорошие закуски.",
        "Много пива, но оно всё паршивое.",
      ],
      badges: [BarBadgeId.BadBeer],
      ratings: {
        Размер: 5,
        Атмосфера: 2,
        Цены: 3,
        Напитки: 2,
        Еда: 4,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.StayTrue,
    title: "Stay true bar",
    address: "Москва, ​​Славянская пл., 2/5/4 ст3",
    latlng: { lat: 55.75304776347778, lng: 37.63529777526856 },
  },
  {
    id: BarId.Lovecraft,
    title: "Лавкрафт",
    address: "Малышева, 64",
    latlng: { lat: 56.835032017899884, lng: 60.610156059265144 },
  },
  {
    id: BarId.RustyDed,
    title: "Ржавый ДЕД",
    address: "Тюмень, ул. Хохрякова, 47",
    latlng: { lat: 57.15571743910638, lng: 65.54198741912843 },
  },
  {
    id: BarId.Kotze,
    title: "Kotze Bar",
    address: "Санкт-Петербург, Мучной пер., 9/27",
    latlng: { lat: 59.92957120640115, lng: 30.323467254638675 },
    closed: true,
  },
  {
    id: BarId.Mishka,
    title: "Mishka",
    address: "Санкт-Петербург, Конногвардейский бул., 4",
    latlng: { lat: 59.93270729680321, lng: 30.297980904579166 },
  },
  {
    id: BarId.Poison,
    title: "Poison",
    address: "Санкт-Петербург, ул. Рубинштейна, 11",
    latlng: { lat: 59.929691, lng: 30.34422 },
  },
  {
    id: BarId.Teremok,
    title: "Teremok",
    address: "Тюльган, ул. Максима Горького, 9А",
    latlng: { lat: 52.34111, lng: 56.160453 },
  },
  {
    id: BarId.Dogma,
    title: "Dogma bar",
    address: "Тюмень, Советская ул., 55/1А",
    latlng: { lat: 57.155252, lng: 65.546492 },
  },
  {
    id: BarId.Misantrope,
    title: "Мизантроп",
    address: "ул. 8 Марта, 14",
    latlng: { lat: 56.834975, lng: 60.602578 },
    closed: true,
  },
  {
    id: BarId.Boroda,
    title: "Борода",
    address: "ул. Бажова, 91, этаж 1",
    latlng: { lat: 56.84143, lng: 60.626006 },
  },
  {
    id: BarId.BioShmio,
    title: "Био Шмио",
    address: "ул. Малышева, 61",
    latlng: { lat: 56.836262, lng: 60.620201 },
  },
  {
    id: BarId.PushInBar,
    title: "Push in bar",
    address: "ул. Малопрудная, 5",
    latlng: { lat: 56.809662, lng: 60.493664 },
  },
  {
    id: BarId.Spletni,
    title: "Сплетни",
    address: "ул. Куйбышева, 61",
    latlng: { lat: 56.827971, lng: 60.607927 },
    info: {
      review: [
        "Бар, где можно НАКИДАТЬСЯ.",
        "Сесть негде и некуда, пробраться к стойке можно только с боем.",
        "Есть второй выход на большую территорию, где можно орать.",
      ],
      badges: [BarBadgeId.BadBeer],
      ratings: {
        Размер: 3,
        Атмосфера: 3,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 1,
      },
    },
  },
  {
    id: BarId.Geograf,
    title: "Географ",
    address: "ул. Куйбышева, 61",
    latlng: { lat: 56.827941, lng: 60.607624 },
    info: {
      review: [
        "Бар по соседству со сплетнями, куда ходят те, кто боится сплетен.",
        "Есть крафтовое пиво и сомнительные закуски.",
      ],
      badges: [BarBadgeId.GoodBeer, BarBadgeId.Sabotage],
      ratings: {
        Размер: 3,
        Атмосфера: 2,
        Цены: 4,
        Напитки: 4,
        Еда: 1,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Izakaya,
    title: "Izakaya",
    address: "ул. Пушкина, 12",
    latlng: { lat: 56.837093, lng: 60.609167 },
    info: {
      review: [
        "Бар с необычным и очень стильными коктейлями, но с ними нужно быть осторожным: часть из них прекрасна, а часть напоминает по вкусу стекломой.",
        "'Нужно брать гепарда, он быстрее' - так сказал Саня, что бы это ни значило.",
        "Внизу есть кальян.",
        "Говорят, что тут ещё кормят, но мы не проверяли.",
      ],
      badges: [
        BarBadgeId.UniqueCocktails,
        BarBadgeId.GoodCocktails,
        BarBadgeId.Hookah,
      ],
      ratings: {
        Размер: 4,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 5,
        Еда: 0,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Kritik,
    title: "Критик",
    address: "Красноармейская ул., 8",
    latlng: { lat: 56.837399, lng: 60.615528 },
    info: {
      review: [
        "Никогда не видел, чтобы пиво наливали так медленно. Проходили минуты, часы, дни, недели... а наше пиво всё наливалось и наливалось.",
        "Выйдя седым из этого бара, я долго думал о проведённых здесь годах.",
        "За баром есть калитка, которая была не закрыта, и я чуть не навернулся башкой в землю.",
      ],
      badges: [BarBadgeId.BadBeer],
      ratings: {
        Размер: 2,
        Атмосфера: 1,
        Цены: 4,
        Напитки: 2,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.SleepingDog,
    title: "Спящая собака",
    address: "Первомайская ул., 40",
    latlng: { lat: 56.84283, lng: 60.62056 },
    info: {
      review: ["Ну, здесь только в мясо накидываться."],
      badges: [BarBadgeId.GoodTincture],
      ratings: {
        Размер: 1,
        Атмосфера: 4,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Mivino,
    title: "Mivino lounge bar",
    address: "просп. Ленина, 69, корп. 14",
    latlng: { lat: 56.842901, lng: 60.621703 },
    info: {
      review: [
        "Мы сюда зашли уже убранные в нули, и я почти ничего не помню, кроме того, что заказал Белого русского, и он меня устроил",
      ],
      badges: [BarBadgeId.GoodCocktails],
      ratings: {
        Размер: 4,
        Атмосфера: 3,
        Цены: 3,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Yankee,
    title: "The Yankee Bar",
    address: "ул. Толмачёва, 25",
    latlng: { lat: 56.841185, lng: 60.608505 },
    info: {
      review: ["Небольшой бар с крафтом"],
      badges: [BarBadgeId.CraftBeer],
      ratings: {
        Размер: 2,
        Атмосфера: 3,
        Цены: 3,
        Напитки: 4,
        Еда: 3,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Bukowski,
    title: "Буковски Гриль",
    address: "ул. Карла Либкнехта, 32",
    latlng: { lat: 56.841087, lng: 60.611228 },
  },
  {
    id: BarId.Opyt,
    title: "Опыт",
    address: "Первомайская ул., 11В",
    latlng: { lat: 56.842644, lng: 60.612958 },
    info: {
      review: [
        "Большой бар с двумя выходами на улицу и внутренним двором, про который никто не знает",
      ],
      badges: [BarBadgeId.CraftBeer, BarBadgeId.Sabotage],
      ratings: {
        Размер: 4,
        Атмосфера: 3,
        Цены: 3,
        Напитки: 4,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Melody,
    title: "Мелодия",
    address: "Первомайская ул., 36",
    latlng: { lat: 56.84273, lng: 60.618659 },
    info: {
      review: [
        "Помещение представляет собой коридор, в который может протиснуться половина человека. Я еле выбрался оттуда, и то не целиком...",
        "Настойки тут конечно оставляют желать лучшего.",
      ],
      badges: [],
      ratings: {
        Размер: 1,
        Атмосфера: 1,
        Цены: 5,
        Напитки: 2,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.RosyJane,
    title: "The Rosy Jane",
    address: "ул. Пушкина, 11",
    latlng: { lat: 56.837917, lng: 60.607934 },
  },
  {
    id: BarId.Fjord,
    title: "Fjord",
    address: "ул. Пушкина, 7",
    latlng: { lat: 56.836513, lng: 60.608633 },
    info: {
      review: [
        "Всё с этим баром было бы хорошо, если бы не СРАНАЯ стойка, которая стоит в анусе, и к которой невозможно пробраться в здравом уме и рассудке, а потом ещё и выбраться оттуда, не пролив всё, что забрал.",
        "Есть настойки с перцем, которые оказывают на человека летальное воздействие.",
      ],
      badges: [],
      ratings: {
        Размер: 1,
        Атмосфера: 2,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.RedCooper,
    title: "Red Cooper Bar",
    address: "просп. Ленина, 36",
    latlng: { lat: 56.838491, lng: 60.608645 },
  },
  {
    id: BarId.UncleHoward,
    title: "Uncle Howard",
    address: "ул. Малышева, 64",
    latlng: { lat: 56.835016, lng: 60.610151 },
  },
  {
    id: BarId.Air,
    title: "Air",
    address: "ул. Радищева, 1",
    latlng: { lat: 56.830322, lng: 60.600307 },
  },
  {
    id: BarId.BenHall,
    title: "Ben Hall",
    address: "ул. Народной Воли, 65",
    latlng: { lat: 56.826089, lng: 60.612162 },
  },
  {
    id: BarId.Mom,
    title: "Мам я в хлам",
    address: "ул. Малышева, 29",
    latlng: { lat: 56.833731, lng: 60.59504 },
  },
  {
    id: BarId.Mint,
    title: "Мята Lounge",
    address: "ул. Попова, 2",
    latlng: { lat: 56.835773, lng: 60.594697 },
  },
  // 4
  {
    id: BarId.TacoMago,
    title: "Taco mago",
    address: "ул. Тургенева, 3",
    latlng: { lat: 56.840531, lng: 60.614581 },
  },
  {
    id: BarId.Amigos,
    title: "Алехандро амигос",
    address: "ул. Пушкина, 4",
    latlng: { lat: 56.836027, lng: 60.6097 },
    info: {
      review: [
        "Бар в мексиканском стиле с запутанными барными стойками. Тут вам нальют настолько убийственные коктейли и настойки, что вы точно проснётесь в Мексике.",
      ],
      badges: [BarBadgeId.GoodTincture, BarBadgeId.GoodDesign],
      ratings: {
        Размер: 2,
        Атмосфера: 4,
        Цены: 4,
        Напитки: 4,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.Stavnikov,
    title: "Ставников",
    address: "ул. Розы Люксембург, 14",
    latlng: { lat: 56.83408, lng: 60.611693 },
  },
  {
    id: BarId.Pils,
    title: "Pils live bar",
    address: "ул. Карла Маркса, 13",
    latlng: { lat: 56.830787, lng: 60.612956 },
    info: {
      review: [
        "Продолговатый и уютный бар с живой музыкой. Нас дважды спрашивали, зачем мы приходим в пивной бар пить егерь с колой, но нас было не переубедить.",
        "Тут подают прекрасный паштет из индейки.",
      ],
      badges: [BarBadgeId.GoodCocktails],
      ratings: {
        Размер: 3,
        Атмосфера: 5,
        Цены: 4,
        Напитки: 5,
        Еда: 5,
        Музыка: 5,
      },
    },
  },
  {
    id: BarId.Onegin,
    title: "Онегин",
    address: "ул. Розы Люксембург, 49",
    latlng: { lat: 56.829188, lng: 60.614474 },
  },
  {
    id: BarId.GrottSpot,
    title: "Grott spot",
    address: "​Улица Московская, 198",
    latlng: { lat: 56.800731, lng: 60.593661 },
  },
  {
    id: BarId.Podpolie,
    title: "Подполье",
    address: "​Хохрякова, 72, 2 этаж​",
    latlng: { lat: 56.827469, lng: 60.594178 },
    info: {
      review: [
        "Совершенно секретный бар, находящийся в подполье (на втором этаже). Его трудно найти, легко потерять и невозможно забыть.",
        "Здесь есть миллион видов настоек, кальян и диван.",
      ],
      badges: [BarBadgeId.GoodTincture, BarBadgeId.Hookah],
      ratings: {
        Размер: 5,
        Атмосфера: 4,
        Цены: 5,
        Напитки: 5,
        Еда: 0,
        Музыка: 0,
      },
    },
  },
  {
    id: BarId.ForeverYoung,
    title: "Вечно молодой",
    address: "Сириус. ​Цимлянская, 15/1",
    latlng: { lat: 43.391158, lng: 39.980968 },
    info: {
      review: ["Хороший бар с крафтовым пивом"],
      badges: [BarBadgeId.CraftBeer],
      ratings: {
        Размер: 3,
        Атмосфера: 4,
        Цены: 3,
        Напитки: 5,
        Еда: 0,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.BreakingBad,
    title: "Breaking Bad bar",
    address: "Адлер, Сочи. Бестужева, 1/1",
    latlng: { lat: 43.418068, lng: 39.922968 },
    info: {
      review: ["Довольно странный бар со слишком громкой музыкой"],
      badges: [],
      ratings: {
        Размер: 5,
        Атмосфера: 1,
        Цены: 3,
        Напитки: 2,
        Еда: 0,
        Музыка: 1,
      },
    },
  },
  {
    id: BarId.Bushes,
    title: "Кусты",
    address: "Банковский переулок, 10",
    latlng: { lat: 56.834481, lng: 60.597082 },
    info: {
      review: [
        "Маленький уютный бар с крафтовым пивом. Есть проигрыватель пластинок.",
      ],
      badges: [
        BarBadgeId.CraftBeer,
        BarBadgeId.Games,
        BarBadgeId.Sabotage,
        BarBadgeId.GoodMusic,
      ],
      ratings: {
        Размер: 2,
        Атмосфера: 4,
        Цены: 3,
        Напитки: 3,
        Еда: 0,
        Музыка: 4,
      },
    },
  },
  {
    id: BarId.Salut,
    title: "Салют",
    address: "Толмачёва, 17",
    latlng: { lat: 56.838006, lng: 60.609693 },
    info: {
      review: [
        "Маленький уютный бар с крафтовым пивом. Есть старая люстра и стол как у моей бабушки.",
      ],
      badges: [
        BarBadgeId.CraftBeer,
        BarBadgeId.Sabotage,
        BarBadgeId.GoodDesign,
      ],
      ratings: {
        Размер: 3,
        Атмосфера: 4,
        Цены: 3,
        Напитки: 2,
        Еда: 0,
        Музыка: 3,
      },
    },
  },
  {
    id: BarId.Pocherk,
    title: "Почерк by InTouch",
    address: "Пушкина, 12",
    latlng: { lat: 56.837198, lng: 60.60931 },
    info: {
      review: ["Бар с теми самым коктейлями, как в старом интаче. Места мало."],
      badges: [BarBadgeId.GoodCocktails],
      ratings: {
        Размер: 1,
        Атмосфера: 3,
        Цены: 2,
        Напитки: 5,
        Еда: 0,
        Музыка: 2,
      },
    },
  },
]
